<template>
	<div :class="{ 'isLoading': isLoading }">
		<transition name="fade">
			<div wrap
				v-if="!isLoading"
				class="searcher-input-wrapper"
				:style="`height: ${height}px`"
			>
				<input
					flat
					solo
					class="searcher-input"
					v-bind="$attrs"
					:height="height"
					@keyup.enter="$emit('open-searcher')"
					@input="$emit('input', $event.target.value)"
				/>
				<button
					type="button"
					:dark="!disabled"
					class="search-btn ma-0"
					:disabled="disabled"
					@click="$emit('open-searcher')"
				>
					<v-icon class="search-icon">search</v-icon>
				</button>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'input-searcher',
		inheritAttrs: false,
		props: {
			height: {
				default: 30,
				type: Number,
			},
			isLoading: {
				type: Boolean,
				default: false,
			},
			disabled: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>
<style lang="scss" scoped>
	.searcher-input-wrapper {
		align-items: center;
		background-color: white;
		border: 1px solid color(grey-icon);
		border-radius: 5px;
		display: flex;
		font-family: 'AvenirRegular';
		font-size: 12px;
		height: 32px;
		justify-content: space-between;
		padding-left: 10px;
	}

	.searcher-input {
		flex: 1 1 80%;
		overflow: hidden;
		padding-right: 5px;
	}

	.searcher-input:focus {
		height: 100%;
		outline: none;
	}

	.search-btn {
		align-items: center;
		background-color: color(secondary);
		border: 1px solid color(secondary);
		// border-top-right-radius: 15px;
		// border-bottom-right-radius: 15px;
		border-radius: 5px;
		cursor: pointer;
		display: flex;
		flex: 1 1 5%;
		height: 32px;
		justify-content: center;
		min-width: 36px;
	}

	.search-btn:disabled {
		background-color: color(grey-icon);
		border: 1px solid color(grey-icon);
		cursor: not-allowed;
	}

	.search-icon {
		color: color(white) !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/searcher/input-searcher.vue